<template>
	<div>
		<v-content>      
			<v-container fluid>              
              <center><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="packagesLoaded == false" /></center>
              <v-flex xs3>
                <div class="relative">
                  <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
                  <v-text-field v-if="packagesLoaded == true && search != ''" label="Search" solo single-line v-model="search"></v-text-field>
                  <v-text-field append-icon="search" v-if="packagesLoaded == true && search == ''" label="Search" solo single-line v-model="search"></v-text-field><br />
                </div>
              </v-flex>				
				<v-data-table :headers="headers" v-if="packagesLoaded == true" :search="search" id="hello" :items="packageList" class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">						
						<td width="10%" class="text-xs-right">{{ props.item.name }}</td>      
						<td width="20%" class="text-xs-right">{{ props.item.short_name }}</td>
                        <td width="30%" class="text-xs-right">{{ props.item.description }}</td>
						<td width="10%" class="text-xs-right">{{ props.item.created }}</td>						
                        <td width="10%" class="text-xs-right">{{ props.item.modified }}</td>						
						<td width="10%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1"><a @click.prevent="fncEditPackage(props.item.id)"><i class="material-icons">edit</i></a></td>						
						<td width="10%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1"><a @click.prevent="fncDeletePackage(props.item.id)"><i class="material-icons">delete_forever</i></a></td>						
					</template>
				</v-data-table>
			</v-container>
		</v-content>		
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex';  

  export default {
	name: 'StatusList',
	intRoleEdit: 0,
    data () {
		return {	
			search: '',
			headers: [         
				{ text: 'Name', value: 'name', width: '10%' },
                { text: 'Short Name', value: 'short_name', width: '20%' },
                { text: 'Description', value: 'description', width: '30%' },
                { text: 'Created On', value: 'created', width: '10%' },
                { text: 'Modified On', value: 'modified', width: '10%' },
                { text: 'Edit', value: 'edit', width: '10%' },	
                { text: 'Delete', value: 'delete', width: '10%' }			
			]
		}
	},
    methods: {
      fncClearSearch() {
        this.search = '';
      },
      fncEditPackage(packageId) {
            this.$store.dispatch({
              type: 'setObjPackageEdit',
              id: packageId
            });
			/*this.$store.commit({
				type: 'setObjPackageEdit',
                id: packageId
			});*/
            /*var modalDetails = { title: 'Edit Package', component: 'modal-package-edit', mstate: true, params: { packageId: packageId} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});*/
		},
        fncDeletePackage(packageId ) {
			var deleteConfirm = confirm('Are you sure you want to remove this package?');
			if(deleteConfirm === true) {
				this.$store.dispatch({
					type: 'fncDeletePackage',
                    packageId: packageId
				})
			}
		}
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'packageList',
            'globalModalParams',
            'packagesLoaded'
		])
	},
	beforeMount() {
        this.$store.dispatch('fncPopulatePackages');		
	},
	created() {		
	}
}	
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>